import { FC } from "react";
import { Link } from "react-router-dom";
import { Flex, Image } from "@chakra-ui/react";
import { routes } from "~/constants";
import { trackHeader as track } from "~/events";
import { useCurrentUser } from "~/hooks/useCurrentUser";
import ConceiveLogo from "~/images/logos/conceive.svg";

const alt = {
  logo: "Large Conceive logo",
};

type Monitor = "mobile" | "desktop";

interface Props {
  monitor: Monitor;
}

interface Sizes {
  height: string;
  width: string;
}

const monitorToSizes: Record<Monitor, Sizes> = {
  mobile: {
    height: "1.5rem",
    width: "9rem",
  },
  desktop: {
    height: "2rem",
    width: "12rem",
  },
};

export const Logo: FC<Props> = ({ monitor }) => {
  const user = useCurrentUser();

  const { height, width } = monitorToSizes[monitor];

  const to = user?.isOnboarded ? routes.dashboard : routes.root;

  return (
    <Flex>
      <Link onClick={track.homeLink} to={to}>
        <Image
          alt={alt.logo}
          h={height}
          loading="eager"
          w={width}
          src={ConceiveLogo}
        />
      </Link>
    </Flex>
  );
};
